var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8065 0H5.19355C2.32523 0 0 2.32523 0 5.19355V40.8065C0 43.6748 2.32523 46 5.19355 46H40.8065C43.6748 46 46 43.6748 46 40.8065V5.19355C46 2.32523 43.6748 0 40.8065 0Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0976 24.7761V35.7916L35.5302 29.5488C35.7422 29.433 35.9192 29.2624 36.0425 29.0546C36.1658 28.8469 36.2309 28.6098 36.2309 28.3682V18.1505L24.0976 24.7761ZM11.0289 29.5488L22.4616 35.7914V24.7759L10.3281 18.1502V28.3682C10.3281 28.8603 10.5967 29.313 11.0289 29.5488ZM35.413 16.7327L23.9241 10.459C23.7264 10.351 23.5047 10.2944 23.2794 10.2944C23.0541 10.2944 22.8324 10.351 22.6347 10.459L17.6354 13.1884L29.7416 19.814L35.413 16.7327ZM15.9177 14.1423L11.1461 16.7327L23.2796 23.3311L28.0239 20.7407L15.9177 14.1423Z",
    fill: "#7E807E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacked);
export default __webpack_public_path__ + "static/media/packed.efc765f65e9626560b44e57427c0a267.svg";
export { ForwardRef as ReactComponent };